import templateUrl from 'emun.on-demand/media/upload-media.htm'
import UploadMediaController from 'emun.on-demand/media/upload-media.controller'

let UploadMediaComponent = {
    bindings: {
        notifySubscription: '@',
        subscriptionId: '@',
        onSaved: '&'
    },
    controller: UploadMediaController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default UploadMediaComponent;
